import store from "@/store"
import Vue from 'vue'

export function initUpload() {
	/**
	 * 上传Manifest
	 */

	$("#files").fileinput({
		language: store.getters.lang,
		uploadUrl: Vue.prototype.apiUrl + "UploadInvoicePurchaseOrder/fileupload",
		enctype: 'multipart/form-data',
		allowedFileExtensions: ['xls', 'xlsx'],
		uploadAsync: true, //默认异步上传
		showUpload: true, //是否显示上传按钮
		showRemove: true, //显示移除按钮
		showCancel: true,//显示取消按钮
		showPreview: false,//不显示预览
		dropZoneEnabled: false,//不允许拖拽
		maxFileSize: 10240,//kb 最大上傳大小10MB
		maxFileCount: 1,//表示允许同时上传的最大文件个数
		textEncoding: "UTF-8",
		headers: {
			"Authorization": "Bearer " + store.getters.token,
			"Accept-Language": store.getters.lang
		}
	});

	$("#files").on("fileuploaded", function (event, data, previewId, index) {
		var result = data.response;
		$("#errorInfo").html(result.message);
		if (result.code != 200) {
			return;
		}
		//请求服务器解析上传的文件
		analysisFile(result.data);
		$(".kv-upload-progress").hide(500);
	});
	$('#files').on('fileerror', function (event, data, msg) {
		$("#errorInfo").html(msg);
	});
}




// 解析结果
function analysisFile(param) {
	if (param == undefined || param == null) {
		return false;
	}

	$.ajax({
		type: "POST",
		url: Vue.prototype.apiUrl + "UploadInvoicePurchaseOrder/readFile",
		data: JSON.stringify({ "fileName": param }),
		//dataType: "json",
		contentType: "application/json",
		cache: false,
		headers: {
			"Authorization": "Bearer " + store.getters.token,
			"Accept-Language": store.getters.lang
		},
		success: function (data, textStatus) {
			try {
				$("#errorInfo").append("<br/>")
				$("#errorInfo").append(data.message);
			} catch (e) {

			}
		},
		error: function (XMLHttpRequest, textStatus, errorThrown) {
			alert(errorThrown);
		}
	});

	return true;
}

